import './App.css';

import { BrowserRouter as Router } from "react-router-dom";
import { useEffect, useCallback } from "react";
import { useQuestion } from "./store/useQuestion";
import { LanguageProvider } from './contexts/LanguageContext';
import { STORAGE_KEYS } from './constants/storageKeys';
import { AppRoutes } from "./routes";
import React from "react";

function App() {
  const setQuestion = useQuestion(s => s.setQuestion);
  const setLoading = useQuestion(s => s.setLoading);
  const setError = useQuestion(s => s.setError);

  const fetchQuestions = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`/api/questions`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const json = await res.json();
      console.log("Fetched questions:", json);

      setQuestion(json.questions);

      const nQuestions = Object.keys(json.questions).length;
      console.log("Number of questions:", nQuestions);
      localStorage.setItem(STORAGE_KEYS.N_QUESTIONS, nQuestions.toString());
    } catch (error) {
      console.error("Failed to fetch questions:", error);
      setError(error.message);
    }
  }, [setQuestion, setLoading, setError]);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEYS.STAY_LOGIN, "false");
    fetchQuestions();
  }, [fetchQuestions]);

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <LanguageProvider>
        <Router>
          <AppRoutes />
        </Router>
      </LanguageProvider>
    </React.Suspense>
  );
}

export default App;
